module.exports = __webpack_public_path__ + "img/tomtom.fef11a2a.svg";